import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PropTypes from 'prop-types';
import { navigate } from '../../actions';
import ReportGeneric from '../report_generic';

import { withStyles } from '@material-ui/core/styles';

import * as config from '../../constants/configuration';

const styles = theme => ({
    toolbar: {
        display: 'block',
        minHeight: '112px'
    }
});

class InfResumenVentas extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

    };

    render() {

        const { classes } = this.props;

        return (
            <div>
                <div className={classes.toolbar} />
                {this.props.user ? <ReportGeneric reportId={8} /> : null}
            </div>
        );

    };

};

InfResumenVentas.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(InfResumenVentas));